import styled from "styled-components";

import { ProgressBar } from "@8x8/oxygen-loaders";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const StyledProgressBar = styled(ProgressBar)`
  display: flex;
  flex: 1;

  & > progress {
    margin-bottom: 0;
  }
`;

const Counter = styled.div`
  display: flex;
`;

const CountCell = (props) => {
  const currentValue = props?.getValue?.();
  const rowData = props.row?.original ?? {};
  const totalCount = rowData?.stats?.totalJobs ?? 0;
  const percentage =
    totalCount !== 0 ? Math.floor((currentValue / totalCount) * 100) : 0;

  return (
    <Container>
      <StyledProgressBar fullWidth size="small" value={percentage} />
      <Counter>{`${currentValue} / ${totalCount}`}</Counter>
    </Container>
  );
};

export default CountCell;
